// extracted by mini-css-extract-plugin
module.exports = {"ProLiteIndicator":"ProLiteIndicator_ProLiteIndicator__3LN9c","pro":"ProLiteIndicator_pro__2EKBJ","text":"ProLiteIndicator_text__10ROk","lite":"ProLiteIndicator_lite__17-5R"};